<template>
	<div class="popup" style="width:700px;" v-click-outside="() => $emit('closePop')">
		<!-- 회원정보 수정 폼 -->
		<div class="popup-top">
			<strong>{{ lang.title('myInfo') }}</strong>
			<button class="btn-back" @click="$emit('closePop')"></button>
			<button class="btn-close mob-hide" @click="$emit('closePop')"></button>
		</div>
		<div class="popup-btm">
			<div class="btn-out-wrap">
				<v-btn class="custom-btn btn-white mr--auto" @click="$emit('openWithdraw')">{{ lang.button('withdraw') }}</v-btn>
			</div>
			<div class="form-view">
				<v-form ref="form" v-model="isFormValid" lazy-validation>
					<table>
						<colgroup>
							<col style="width:150px">
							<col>
						</colgroup>
						<tbody>
						<!--          <tr class="mob-hide">
												<th>권한</th>
												<td>사용자</td>
											</tr>-->
						<tr>
							<th>{{ lang.label('loginId') }}</th>
							<td>
								<v-text-field
									v-model="loginName"
									class="custom-input form disabled-input"
									disabled>
								</v-text-field>
							</td>
						</tr>
						<tr>
							<th>{{ lang.label('password') }} <span class="bullet">*</span></th>
							<td>
								<v-btn class="custom-btn btn-white mini no-wrap" @click="pwdChg = !pwdChg" style="width:fit-content; max-width:fit-content;">
									{{ pwdChg ? lang.button('passwordKeep') : lang.button('passwordChange') }}
								</v-btn>
							</td>
						</tr>
						<tr v-if="pwdChg">
							<th>{{ lang.label('newPassword') }}</th>
							<td>
								<v-text-field
									v-model="newPassword"
									type="password"
									class="custom-input form"
									:placeholder="lang.placeholder('password')"
									:error-messages="passwordErrors.password"
									@blur="validatePasswordField('password')">
									<template #message="{ message }">
										{{ t(message) }}
									</template>
								</v-text-field>
								<p class="fons12 mt--8 color-blue">{{ lang.text('passwordRequirement') }}</p>
							</td>
						</tr>
						<tr v-if="pwdChg">
							<th>{{ lang.label('newPasswordConfirm') }}</th>
							<td>
								<v-text-field
									v-model="newPasswordConfirm"
									type="password"
									class="custom-input form"
									:placeholder="lang.placeholder('passwordConfirm')"
									:error-messages="passwordErrors.passwordConfirm"
									@blur="validatePasswordField('passwordConfirm')">
									<template #message="{ message }">
										{{ t(message) }}
									</template>
								</v-text-field>
							</td>
						</tr>
						<tr>
							<th>{{ lang.label('name') }} <span class="bullet">*</span></th>
							<td>
								<v-text-field
									v-model="newUserName"
									class="custom-input form"
									:placeholder="lang.placeholder('name')"
									:error-messages="fieldErrors.name"
									@blur="validateField('name')">
									<template #message="{ message }">
										{{ t(message) }}
									</template>
								</v-text-field>
							</td>
						</tr>
						<tr>
							<th>{{ lang.label('position') }} <span class="bullet">*</span></th>
							<td>
								<v-text-field
									v-model="newPosition"
									class="custom-input form"
									:placeholder="lang.placeholder('position')"
									:error-messages="fieldErrors.position"
									@blur="validateField('position')">
									<template #message="{ message }">
										{{ t(message) }}
									</template>
								</v-text-field>
							</td>
						</tr>
						<tr>
							<th>{{ lang.label('phone') }} <span class="bullet">*</span></th>
							<td>
								<v-text-field
									v-model="newContact"
									class="custom-input form"
									style="max-width:310px"
									:placeholder="lang.placeholder('phone')"
									:error-messages="fieldErrors.phone"
									@blur="validateField('phone')">
									<template #message="{ message }">
										{{ t(message) }}
									</template>
								</v-text-field>
								<!--              <v-btn class="custom-btn btn-white mini">중복확인</v-btn>-->
							</td>
						</tr>
						<tr>
							<th>{{ lang.label('email') }} <span class="bullet">*</span></th>
							<td class="custom-email-userinfo">
								<v-text-field
									v-model="newEmailId"
									class="custom-input form"
									style="max-width:145px"
									:placeholder="lang.placeholder('emailLocal')"
									:error-messages="fieldErrors.emailLocal"
									@blur="validateField('emailLocal')"
									clearable>
									<template #message="{ message }">
										{{ t(message) }}
									</template>
								</v-text-field>
								<span class="txt email-txt">@</span>
								<v-combobox
									v-model="newEmailDomain"
									:items="emailDomainList"
									variant="outlined"
									style="max-width:200px"
									class="custom-select form"
									clearable
									:placeholder="lang.placeholder('emailDomain')"
									:error-messages="fieldErrors.emailDomain"
									@blur="validateField('emailDomain')"
									autocomplete="off">
									<template #message="{ message }">
										{{ t(message) }}
									</template>
								</v-combobox>
								<!--              <v-btn class="custom-btn btn-white mini">중복확인</v-btn>-->
							</td>
						</tr>
            <tr>
              <th>
                {{ lang.label('alarmReceive') }}
                <span class="bullet">*</span>
              </th>
              <td>
                <v-select
                    v-model="isReceivingAlarm"
                    :items="selectReceiveAlarmList"
                    item-value="value"
                    item-title="label"
                    variant="outlined"
                    style="max-width:140px"
                    class="custom-select form"
                    hide-details
                >
                </v-select>
              </td>
            </tr>
						</tbody>
					</table>
				</v-form>
			</div>
		</div>
		<div class="popup-btn">
			<v-btn class="custom-btn btn-white mr--auto mob-hide" @click="$emit('openWithdraw')">{{ lang.button('withdraw') }}</v-btn>
			<v-btn class="custom-btn btn-white mob-hide" @click="$emit('closePop')">{{ lang.button('cancel') }}</v-btn>
			<v-btn class="custom-btn btn-blue" :disabled="!isFormValid" @click="fnSave()">{{ lang.button('submit') }}</v-btn>
		</div>
	</div>
</template>

<style scoped lang="scss">
:root {
	--combobox-border-color: transparent;
	--combobox-text-color: #000;
}

html:has(.darkmode) {
	--combobox-border-color: transparent;
	--combobox-text-color: #fff;
}

.custom-select .v-combobox__selection-text {
	font-size: 14px;
	font-weight: 400;
	color: var(--combobox-text-color) !important;
}

.custom-select input {
	border-color: var(--combobox-border-color) !important;
	background-color: transparent !important;
	font-size: 14px;
	font-weight: 400;
	color: var(--combobox-text-color) !important;
}

.txt.email-txt {
	color: var(--combobox-text-color);
}

.no-wrap :deep(.v-btn__content) {
	white-space: nowrap !important;
}

.disabled-input :deep(.v-field__input) {
	color: var(--combobox-text-color) !important;
	opacity: 1 !important;
}

.disabled-input :deep(.v-field--disabled) {
	opacity: 1 !important;
}

.disabled-input :deep(.v-field--disabled .v-field__input) {
	color: var(--combobox-text-color) !important;
}
</style>

<script setup lang="ts">
import { useMyInfo } from "~/composables/useMyInfo";
import { useConstantData } from "~/composables/useConstantData";
import { useHandleCode } from "~/composables/useHandleCode";
import { useLanguage } from "~/composables/useLanguage";
import { useI18n } from "vue-i18n";
import { useValidation } from "~/composables/useValidation";

const { lang } = useLanguage();
const { t } = useI18n();

const {
	validatePasswordConfirm,
	validatePassword,
	validateName,
	validatePosition,
	validatePhone,
	validateEmailLocal,
	validateEmailDomain
} = useValidation();

const {
	loginName,//로그인 아이디
	userName,//사용자 이름
	position,//직급
	contact,//휴대폰번호
	emailId,//이메일 아이디
	emailDomain,//이메일 도메인

  isReceivingAlarm,//알림 수신 여부
  selectReceiveAlarmList,

	handleMyInfo,
	handleSaveMyInfo,
} = useMyInfo();

const {
	emailDomainList
} = useConstantData();

const { handleErrorCode } = useHandleCode();

const isFormValid = ref(false)
const pwdChg = ref(false)
const newUserName = ref(userName)
const newPosition = ref(position)
const newContact = ref(contact)
const newEmailId = ref(emailId)
const newEmailDomain = ref(emailDomain)
const newPassword = ref('')
const newPasswordConfirm = ref('')

// 필드별 에러 메시지
const fieldErrors = reactive({
	name: '',
	position: '',
	phone: '',
	emailLocal: '',
	emailDomain: ''
})

// 비밀번호 관련 에러 메시지
const passwordErrors = reactive({
	password: '',
	passwordConfirm: ''
})

// 특정 필드 검증
const validateField = (fieldName: keyof typeof fieldErrors) => {
	let result;

	switch (fieldName) {
		case 'name':
			result = validateName(newUserName.value);
			break;
		case 'position':
			result = validatePosition(newPosition.value);
			break;
		case 'phone':
			result = validatePhone(newContact.value);
			break;
		case 'emailLocal':
			result = validateEmailLocal(newEmailId.value);
			break;
		case 'emailDomain':
			result = validateEmailDomain(newEmailDomain.value);
			break;
		default:
			result = { isValid: true, message: '' };
			break;
	}

	fieldErrors[fieldName] = result?.isValid ? '' : (result?.message || '');
};

// 비밀번호 필드 검증
const validatePasswordField = (field: 'password' | 'passwordConfirm') => {
	if (field === 'password') {
		const { isValid, message } = validatePassword(newPassword.value);
		passwordErrors.password = isValid ? '' : message;
		// 재확인 필드도 다시 검증
		if (newPasswordConfirm.value) {
			validatePasswordField('passwordConfirm');
		}
	} else {
		const { isValid, message } = validatePasswordConfirm(
			newPassword.value,
			newPasswordConfirm.value
		);
		passwordErrors.passwordConfirm = isValid ? '' : message;
	}
};



const fnSave = () => {
	// 1) 사용자가 '비밀번호 변경'을 선택했을 때만 확인 로직 실행
	if (pwdChg.value) {
		const pwd     = newPassword.value.trim();
		const confirm = newPasswordConfirm.value.trim();

		// 2) 하나라도 빈 문자열이거나 일치하지 않으면 알려주고 리턴
		if (!pwd || pwd !== confirm) {
			handleErrorCode("E51005");
			return;
		}
	}

	handleSaveMyInfo({
		password: pwdChg.value ? newPassword.value.trim() : null,
		userName: newUserName.value,
		position: newPosition.value,
		contact: newContact.value,
		email: newEmailId.value+'@'+newEmailDomain.value,
    isReceivingAlarm: isReceivingAlarm.value
	}).then(() => {
		// emit('closePop');
	})
}

onMounted(() => {
	handleMyInfo();
	console.log('emailDomainList', emailDomainList);
})

</script>